import { inject, injectable } from '@servicetitan/react-ioc';
import { MembershipsApi } from 'api';
import { action, makeObservable, observable, runInAction } from 'mobx';

@injectable()
export class MembershipStore {
    @observable membershipsExist = false;
    @observable loaded = false;

    constructor(@inject(MembershipsApi) private membershipsApi: MembershipsApi) {
        makeObservable(this);
        this.loadMembershipsExist();
    }
    @action async loadMembershipsExist() {
        try {
            const membershipsExist = await this.membershipsApi.membershipsExist();
            runInAction(() => {
                this.membershipsExist = membershipsExist;
                this.loaded = true;
            });
        } catch {
            runInAction(() => {
                this.membershipsExist = true;
                this.loaded = true;
            });
        }
    }
}
